import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import SearchBox from '../FlowBuilder/Common/SearchBox/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import DateRangeFilter from '../Shared/DateRangeFilter/DateRangeFilter.tsx';

const BookingPlan: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { campaignId, campaignName, bdOwner, status } = location.state || {};

  const [supplierType, setSupplierType] = useState(null);
  const [bookingStatus, setBookingStatus] = useState(null);
  const [phase, setPhase] = useState(null);
  const [user, setUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

  const breadcrumbsData = [
    { label: <IconButton color="primary"><HomeIcon /></IconButton>, onClick: () => navigate('/') },
    { label: 'Campaigns', onClick: () => navigate('/r/leads/campaigns') },
    { label: 'Booking Plan' },
  ];

  const supplierTypeOptions = [
    { label: 'Supplier A', value: 'supplier_a' },
    { label: 'Supplier B', value: 'supplier_b' },
  ];

  const bookingStatusOptions = [
    { label: 'Confirmed', value: 'confirmed' },
    { label: 'Pending', value: 'pending' },
  ];

  const phaseOptions = [
    { label: 'Phase 1', value: 'phase_1' },
    { label: 'Phase 2', value: 'phase_2' },
  ];

  const userOptions = [
    { label: 'User 1', value: 'user_1' },
    { label: 'User 2', value: 'user_2' },
  ];

  return (
    <Box sx={{
      backgroundColor: '#f8f9f8',
      borderRadius: '12px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      p: 2,
    }}>
      {/* Breadcrumbs */}
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(event, item: { label: string; onClick: () => void }) => item?.onClick?.()}
      />

      {/* Title + Info */}
      <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
  {/* Title */}
  <Grid item xs={12} md={5}>
    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', color: '#333' }}>
      Booking Plan
    </Typography>
  </Grid>

  {/* Campaign Info */}
  <Grid  alignItems="center" item xs={12} md={7}>
    <Box sx={{
      background: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
      px: 2,
      py: 1,
      borderRadius: 1,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
      alignItems: 'center',
    }}>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        <strong>Business Service ID:</strong> {campaignId || 'N/A'}
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        <strong>Business Service Name:</strong> {campaignName || 'N/A'}
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        <strong>BD Owner:</strong> {bdOwner || 'N/A'}
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        <strong>Business Service Status:</strong> {status || 'N/A'}
      </Typography>
    </Box>
  </Grid>
</Grid>


      {/* Filters BELOW Info */}
      <Grid container spacing={1} alignItems="center">
        {/* Search Box */}
        <Grid item xs={12} md={2}>
          <SearchBox
            handleSearch={(query) => setSearchQuery(query)}
            value={searchQuery}
            size="small"
            sx={{
              '& .MuiInputBase-root': {
                height: '40px',
                fontSize: '14px',
              },
            }}
          />
        </Grid>

        {/* Supplier Type */}
        <Grid item xs={12} md={2}>
          <SearchableDropdown
            size="small"
            options={supplierTypeOptions}
            value={supplierType}
            onChange={setSupplierType}
            labelKey="label"
            label="Supplier Type"
          />
        </Grid>

        {/* Booking Status */}
        <Grid item xs={12} md={2}>
          <SearchableDropdown
            size="small"
            options={bookingStatusOptions}
            value={bookingStatus}
            onChange={setBookingStatus}
            labelKey="label"
            label="Booking Status"
          />
        </Grid>

        {/* Phases */}
        <Grid item xs={12} md={2}>
          <SearchableDropdown
            size="small"
            options={phaseOptions}
            value={phase}
            onChange={setPhase}
            labelKey="label"
            label="Phases"
          />
        </Grid>

        {/* User */}
        <Grid item xs={12} md={2}>
          <SearchableDropdown
            size="small"
            options={userOptions}
            value={user}
            onChange={setUser}
            labelKey="label"
            label="User"
          />
        </Grid>

        {/* Next Action Date */}
        <Grid item xs={12} md={2}>
          <DateRangeFilter
            onApply={(range) => setDateRange(range)}
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            sx={{
              '& .MuiButton-root': {
                height: '40px',
                fontSize: '14px',
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BookingPlan;
